import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import * as actionCreators from "../actions/auth";
import { validateToken, get_current_user } from "../utils/http";
import { parseJSON } from "../utils/misc";
import { history } from "../history";

function mapStateToProps(state) {
    return {
        isAuthenticated: state.auth.isAuthenticated,
        username: state.auth.username
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch)
}

export default (Component) => {
    class AuthenticatedComponent extends React.Component {
        componentWillMount() {
            this.setState({
                loaded_if_needed: false,
            });
            this.checkAuth();
        }

        componentWillReceiveProps(nextProps) {
            this.checkAuth(nextProps)
        }

        checkAuth(props = this.props) {
            if (!props.isAuthenticated) {
                const token = localStorage.getItem("token");
                if (!token) {
                    history.push(this.props.location.pathname !== null && this.props.location.pathname !== "/" ?
                        `/login?redirect_to=${this.props.location.pathname}` : "/login")
                } else {
                    validateToken(token).then(r => {
                        if (r.status === 200) {
                            get_current_user(token).then(parseJSON).then(r => {
                                try {
                                    this.props.loginUserSuccess(token, r.username, r.role, r.name, r.organizationIsMaster);
                                    this.setState({
                                        loaded_if_needed: true,
                                    });
                                } catch (e) {
                                    this.props.loginUserFailure({
                                        response: {
                                            status: 403,
                                            statusText: "Ошибка получения информации пользователя.",
                                        },
                                    })
                                }
                            }).catch(() =>{
                                this.props.loginUserFailure({
                                    response: {
                                        status: 403,
                                        statusText: "Ошибка получения информации пользователя.",
                                    },
                                })
                            })
                        } else {
                            history.push("/login")
                        }
                    }).catch(() => {
                        this.props.loginUserFailure({
                            response: {
                                status: 401,
                                statusText: "Неверный токен.",
                            },
                        });
                        this.props.logoutAndRedirect()
                    })

                }
            } else {
                this.setState({
                    loaded_if_needed: true,
                })
            }
        }

        render () {
            return (
                <div>
                    {this.props.isAuthenticated && this.state.loaded_if_needed
                        ? <Component {...this.props}/>
                        : null
                    }
                </div>
            )
        }

    }

    AuthenticatedComponent.propTypes = {
        loginUserSuccess: PropTypes.func,
        loginUserFailure: PropTypes.func,
        isAuthenticated: PropTypes.bool,
        logoutAndRedirect: PropTypes.func,
    };

    return connect(mapStateToProps, mapDispatchToProps)(AuthenticatedComponent);
}



// WEBPACK FOOTER //
// ./src/components/loginRequired.jsx